import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { MessageDescriptor } from '@formatjs/intl';

import { OfferType } from '@sorare/core/src/__generated__/globalTypes';
import { glossary, transferMarket } from '@sorare/core/src/lib/glossary';
import { withFragments } from '@sorare/core/src/lib/gql';

import type { getTransactionType_tokenDeal } from './__generated__/transactions.graphql.ts';

export enum TransactionType {
  AUCTION = 'auction',
  PRIMARY_OFFER = 'primary-offer',
  PUBLIC_OFFER = 'public-offer',
  DIRECT_OFFER = 'direct-offer',
}

export const transactionTypeMessages: Record<
  TransactionType,
  MessageDescriptor
> = {
  [TransactionType.AUCTION]: glossary.auction,
  [TransactionType.PRIMARY_OFFER]: transferMarket.instantBuy,
  [TransactionType.PUBLIC_OFFER]: glossary.trade,
  [TransactionType.DIRECT_OFFER]: transferMarket.directOffer,
};

export const getTransactionType = withFragments(
  ({ deal }: { deal: getTransactionType_tokenDeal }) => {
    switch (deal.__typename) {
      case 'TokenAuction':
        return TransactionType.AUCTION;
      case 'TokenOffer':
        switch (deal.type) {
          case OfferType.SINGLE_BUY_OFFER:
          case OfferType.DIRECT_OFFER:
            return TransactionType.DIRECT_OFFER;
          default:
          case OfferType.SINGLE_SALE_OFFER:
            return TransactionType.PUBLIC_OFFER;
        }
      case 'TokenPrimaryOffer':
      default:
        return TransactionType.PRIMARY_OFFER;
    }
  },
  {
    deal: gql`
      fragment getTransactionType_tokenDeal on TokenOperationTradeInterface {
        id
        ... on TokenOffer {
          id
          type
        }
      }
    ` as TypedDocumentNode<getTransactionType_tokenDeal>,
  }
);
